import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import * as fromCmdbStore from '@apps/cmdb/store';
import { Tag } from '@apps/cmdb/models';
import { getChipsStatus } from '@apps/root/store';

@Component({
    selector: 'aa-chips',
    templateUrl: './chips.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipsComponent implements OnInit, OnChanges
{
    @Input() tagIds: string[];
    @Input() addTag: () => void;
    @Input() isFiltrable: boolean = false;
    @Output() public attachTagEvent: EventEmitter<string> = new EventEmitter();
    @Output() public detachTagEvent: EventEmitter<string> = new EventEmitter();
    @Output() public tagClickEvent: EventEmitter<Tag> = new EventEmitter();
    public tags: Observable<Tag[]>;
    public chipsState: Observable<boolean> = of(false);

    constructor (
        private store: Store<IAuroraState>
    )
    {
    }

    ngOnInit ():void
    {
        this.chipsState = this.store.select(getChipsStatus);
    }

    ngOnChanges (changes: SimpleChanges): void
    {
        this.tags = this.store.select(fromCmdbStore.getTagsByIds, { tagIds: changes.tagIds.currentValue });

    }

    public onAttachTagEvent (tagId: string): void
    {
        this.attachTagEvent.emit(tagId);
    }

    public onDetachTagEvent (tagId: string): void
    {
        this.detachTagEvent.emit(tagId);
    }

    public onTagClickEvent (tag: Tag): void
    {
        this.tagClickEvent.emit(tag);
    }
}
